import Slider from 'components/slider';

const slidersWrap = Array.from(document.querySelectorAll('.j-first-screen-slider'));

if (slidersWrap.length) {
    slidersWrap.forEach((sliderWrap) => {
        // Большой слайдер
        const slider = new Slider();

        slider.init({
            slider       : sliderWrap,
            dots         : false,
            thumbnails   : false,
            arrow        : false,
            counter      : false,
            arrowPosition: 'caption',
            caption      : false,
            noSwipe      : true,
            autoplay     : true,
            autoplaySpeed: 5000,
            infinityLoop : true
        });
    });
}
